// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSColorPalette/index.less
// module id = 1141
// module chunks = 42